import type { FC } from 'react';
import pawBlue from './assets/paw-blue.svg';
import pawGray from './assets/paw-gray.svg';
import * as Styled from './styled';
import type { IconScalePawsProps } from './types';

export * from './types';

export const IconScalePaws: FC<IconScalePawsProps> = (props) => {
  const { amount, maxAmount = 5, ...rest } = props;
  return (
    <Styled.IconsContainer {...rest}>
      <Styled.FilledContainer amount={amount} maxAmount={maxAmount}>
        {new Array(maxAmount).fill(undefined).map((_, index) => {
          return <Styled.Icon key={index} src={pawBlue} alt="" />;
        })}
      </Styled.FilledContainer>
      <Styled.EmptyContainer>
        {new Array(maxAmount).fill(undefined).map((_, index) => {
          return <Styled.Icon key={index} src={pawGray} alt="" />;
        })}
      </Styled.EmptyContainer>
    </Styled.IconsContainer>
  );
};
